var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_33818_35508)",
    d: "M.51.221a1.094 1.094 0 0 0-.25.764v12.03c-.017.277.073.55.25.764l.04.04 6.697-6.74v-.158L.55.18l-.04.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_33818_35508)",
    d: "M9.478 9.327 7.246 7.079V6.92L9.48 4.674l.05.029 2.645 1.512c.756.432.756 1.138 0 1.57L9.53 9.299l-.05.029Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_33818_35508)",
    d: "M9.528 9.297 7.245 7 .508 13.779a.876.876 0 0 0 1.123.033l7.897-4.515Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_33818_35508)",
    d: "M9.528 4.703 1.631.188A.876.876 0 0 0 .508.22l6.737 6.78 2.283-2.298Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M9.478 9.246 1.63 13.732a.896.896 0 0 1-1.083.006l-.04.04.04.04a.896.896 0 0 0 1.083-.006l7.897-4.515-.05-.05Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M.51 13.7a1.094 1.094 0 0 1-.25-.764v.079c-.017.277.073.55.25.764l.04-.04-.04-.04ZM12.176 7.706 9.48 9.246l.05.051 2.646-1.512A.95.95 0 0 0 12.742 7a1.016 1.016 0 0 1-.566.706Z",
    opacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0D13",
    d: "m1.635.266 10.542 6.027a1.007 1.007 0 0 1 .567.706.958.958 0 0 0-.567-.785L1.635.187C.88-.245.262.114.262.985v.079c0-.87.618-1.23 1.373-.798Z",
    opacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33818_35508",
    x1: 6.653,
    x2: -2.475,
    y1: 0.858,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33818_35508",
    x1: 13.158,
    x2: 0.078,
    y1: 7,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33818_35508",
    x1: 8.287,
    x2: -4.091,
    y1: 8.248,
    y2: 20.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33818_35508",
    x1: -1.189,
    x2: 4.339,
    y1: -3.783,
    y2: 1.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.e2244e3a3fb512febb1a00fb667fd237.svg";
export { ForwardRef as ReactComponent };